/* elu-header.js — pagina principală: antetul fix transparent DOAR sus, peste imaginea mare (Kalles, setarea header_transparent).
   Kalles pune clasa „scrolled-past-header” doar la derulare; la încărcarea paginii mai jos de început, la revenire (bfcache) sau la salt
   la o ancoră (#intrebari-frecvente, #lumina-in-casa) antetul ar rămâne o clipă transparent peste text → clasa se pune și aici.
   Idempotent: window.__eluBound.header. */
(function () {
  window.__eluBound = window.__eluBound || {};
  if (window.__eluBound.header) return;
  window.__eluBound.header = true;
  function sync() {
    var h = document.querySelector(".hdt-section-header");
    if (!h) return;
    var sticky = h.querySelector("hdt-sticky-header");
    var limit = sticky ? sticky.offsetHeight : 72;
    if ((window.scrollY || document.documentElement.scrollTop) > limit) h.classList.add("scrolled-past-header");
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sync); else sync();
  window.addEventListener("load", sync);
  window.addEventListener("pageshow", sync);
  window.addEventListener("hashchange", function () { requestAnimationFrame(sync); });
})();
